<script setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
    <path
      d="M1.25 25.25H25.25M1.25 10.5833H25.25M3.91667 5.25L13.25 1.25L22.5833 5.25M2.58333 10.5833V25.25M23.9167 10.5833V25.25M7.91667 15.9167V19.9167M13.25 15.9167V19.9167M18.5833 15.9167V19.9167"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
